class ProductRecommendations extends window.HTMLElement {
    connectedCallback() {
        this.root = this.querySelector("[data-rec-tabs]")
        if (!this.root) return

        this.onTabClick = this.onTabClick.bind(this)
        this.collect()
        this.tabs.forEach((tab) =>
            tab.addEventListener("click", this.onTabClick)
        )

        this.fetchPending().then(() => this.settle())
    }

    collect() {
        this.tabs = Array.from(this.querySelectorAll("[data-rec-tab]"))
        this.panels = Array.from(this.querySelectorAll("[data-rec-panel]"))
    }

    tabFor(id) {
        return this.tabs.find((tab) => tab.dataset.recTab === id)
    }

    // ---------- filling ----------
    fetchPending() {
        const pending = this.panels.filter((panel) =>
            panel.hasAttribute("data-needs-fetch")
        )
        if (!pending.length) return Promise.resolve()

        return Promise.all(pending.map((panel) => this.fillPanel(panel)))
    }

    async fillPanel(panel) {
        const intent = panel.dataset.intent
        const url = `${this.dataset.url}&intent=${encodeURIComponent(intent)}`

        try {
            const response = await fetch(url)
            if (!response.ok) {
                throw new Error(
                    `product-recommendations: ${response.status} fetching ${intent}`
                )
            }

            const doc = new DOMParser().parseFromString(
                await response.text(),
                "text/html"
            )
            const incoming = doc.querySelector(
                `[data-rec-panel][data-intent="${intent}"] custom-carousel`
            )
            const track = incoming?.querySelector("[data-rec-track]")

            if (!track || !track.children.length) {
                panel.setAttribute("data-rec-empty", "")
                return
            }

            panel.querySelector("custom-carousel")?.replaceWith(incoming)
        } catch (error) {
            console.error(error)
            panel.setAttribute("data-rec-empty", "")
        } finally {
            panel.removeAttribute("data-needs-fetch")
        }
    }

    // ---------- resolve what survived ----------
    settle() {
        this.panels.forEach((panel) => {
            if (!panel.hasAttribute("data-rec-empty")) return
            this.tabFor(panel.dataset.recPanelId)?.remove()
            panel.remove()
        })

        this.collect()

        if (!this.panels.length) {
            const section = this.closest("section")
            if (section) section.hidden = true
            return
        }

        this.root.dataset.tabCount = this.panels.length
        this.activate(this.panels[0].dataset.recPanelId)
    }

    // ---------- tabs ----------
    onTabClick(event) {
        this.activate(event.currentTarget.dataset.recTab)
    }

    activate(id) {
        this.panels.forEach((panel) =>
            panel.setAttribute(
                "aria-hidden",
                panel.dataset.recPanelId === id ? "false" : "true"
            )
        )
        this.tabs.forEach((tab) =>
            tab.setAttribute(
                "aria-selected",
                tab.dataset.recTab === id ? "true" : "false"
            )
        )
    }
}

if (!window.customElements.get("product-recommendations")) {
    window.customElements.define("product-recommendations", ProductRecommendations)
}
